import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultOption } from './ResultOption';
import {
    SelectAction,
    type ActionFunction,
    type ResultsProps,
} from './ResultTypes';

export const popularSearchResultsAction: ActionFunction = ({
    metaData,
    result,
}) => {
    trackResultClick(result, metaData.tracking);
    window.location.href = result.url;
    return SelectAction.CLOSE;
};

export function PopularSearchResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    return (
        <ResultGroup
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            <div className="flex flex-wrap">
                {resultGroup.results.map((result) => (
                    <ResultOption
                        className="flex mr-8 mb-8"
                        key={`${result.resultType}-${result.order}-${resultId}`}
                        result={result}
                    >
                        {({ active, ariaLabel }) => (
                            <a
                                aria-label={ariaLabel}
                                className={`inline-block px-20 py-8 text-s! s-text s-bg-hover rounded-full border ${
                                    active ? 's-border' : 'border-transparent'
                                }`}
                            >
                                {result.title}
                            </a>
                        )}
                    </ResultOption>
                ))}
            </div>
        </ResultGroup>
    );
}
